import * as constants from '../constants/CONSTANT';
import axios from 'axios';

/**
 * CRM JWT from localStorage, read on each request.
 * Do not cache at DataApi construction: first import often runs before login, so
 * `this.token` stayed null and `${this.token}` sent the literal string "null",
 * which breaks jsonwebtoken with JsonWebTokenError: jwt malformed.
 */
export function crmAuthHeaders() {
  if (typeof localStorage === 'undefined') {
    return {};
  }
  const raw = localStorage.getItem('token');
  if (!raw || raw === 'null' || raw === 'undefined') {
    return {};
  }
  return { Authorization: raw };
}

export default class DataApi {
  constructor(path) {
    this.baseUrl = `${constants.API_BASE_URL}/api/${path}`; // REST endpoints like /api/contact
  }

  /** Avoid // in URLs when callers pass a leading slash (e.g. `/attachment/id`). */
  _joinBase(pathSuffix) {
    const base = String(this.baseUrl || '').replace(/\/+$/, '');
    const rest = String(pathSuffix ?? '').replace(/^\/+/, '');
    return rest ? `${base}/${rest}` : base;
  }

  fetchAll(queryString = '', config = {}) {
    const url = queryString ? `${this.baseUrl}?${queryString}` : this.baseUrl;
    console.log('fetchAll url: ', url);
    return axios.get(url, {
      headers: {
        ...crmAuthHeaders(),
      },
      ...config, // Allow passing additional config like signal for abort
    });
  }

  // Fetch a single record
  fetchById(id) {
    const url = id ? this._joinBase(id) : this.baseUrl;
    return axios.get(url, {
      headers: {
        ...crmAuthHeaders(),
      },
    });
  }

  // Create a record
  create(data) {
    console.log('data', data);
    return axios.post(this.baseUrl, data, {
      headers: {
        ...crmAuthHeaders(),
      },
    });
  }

  post(url, data) {
    return axios.post(this.baseUrl + url, data, {
      headers: {
        ...crmAuthHeaders(),
      },
    });
  }

  put(url, data) {
    return axios.put(this.baseUrl + url, data, {
      headers: {
        ...crmAuthHeaders(),
      },
    });
  }

  get(url, config = {}) {
    return axios.get(this.baseUrl + url, {
      headers: {
        ...crmAuthHeaders(),
      },
      ...config, // Allow passing additional config like responseType
    });
  }

  // Update a record
  update(data, id) {
    console.log(`Update Method: ${this._joinBase(id)}`);
    return axios.put(this._joinBase(id), data, {
      headers: {
        ...crmAuthHeaders(),
      },
    }); // Update
  }
  // Delete a record
  delete(id) {
    return axios.delete(this._joinBase(id), {
      headers: {
        ...crmAuthHeaders(),
      },
    });
  }

  // Delete with data in body (for bulk operations)
  deleteWithBody(url, data) {
    return axios.delete(this.baseUrl + url, {
      data: data,
      headers: {
        ...crmAuthHeaders(),
        'Content-Type': 'application/json',
      },
    });
  }

  async search(params = {}) {
    const { display_fields, ...otherParams } = params;

    const queryParams = {
      ...otherParams,
      ...(display_fields && { display_fields }),
    };

    const res = await axios.get(this.baseUrl, {
      params: queryParams,
      headers: {
        ...crmAuthHeaders(),
      },
    });

    return res.data;
  }

  // Bulk upsert records
  upsert(data) {
    console.log('upsert payload data: ', data);
    return axios.post(this.baseUrl, data, {
      headers: {
        ...crmAuthHeaders(),
      },
    });
  }
}
